module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../../node_modules/happypack/loader.js?id=jsx!./BillDetailView.js"));
	}, "BillDetailView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=BillDetailView!./src/pages/Store/Wallet/Bill/BillDetail/BillDetailView.js
// module id = 1195
// module chunks = 438